import { BaseService } from "mrb/core";
import { NakiStoreFeaturedSectionFileStreamApiRouteService } from "common/services";

class NakiStoreFeaturedSectionFileStreamService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new NakiStoreFeaturedSectionFileStreamApiRouteService());
    }

    get(id, params, abortSignal = null) {
        const url = this.routeService.get(id, params);
        return this.apiClient.get(url, null, abortSignal);
    }

    getFeaturedSectionCoverImageByGridItemId(featuredSectionItemId, params, abortSignal = null) {
        const url = this.routeService.getFeaturedSectionCoverImageByItemId(featuredSectionItemId, params);
        return this.apiClient.get(url, null, abortSignal);
    }
}

export default NakiStoreFeaturedSectionFileStreamService;
